export default __webpack_public_path__ + "static/media/778.9b8dcb86.png";